export type WorkbenchSessionEventType =
  | "route"
  | "gqlError"
  | "consoleError"
  | "flag"
  | "action";

export type WorkbenchSessionEvent = {
  at: string;
  type: WorkbenchSessionEventType;
  route?: string;
  organizationId?: string;
  operationName?: string;
  message?: string;
  flagKey?: string;
  enabled?: boolean;
};

const EVENT_NAME = "wa:workbench-event";

/**
 * Fire-and-forget hook for code outside the session provider (the Apollo error
 * link sits above it). The provider only records while a session is active.
 */
export function emitWorkbenchEvent(event: Omit<WorkbenchSessionEvent, "at">) {
  window.dispatchEvent(
    new CustomEvent<WorkbenchSessionEvent>(EVENT_NAME, {
      detail: { ...event, at: new Date().toISOString() },
    }),
  );
}

export function onWorkbenchEvent(
  handler: (event: WorkbenchSessionEvent) => void,
): () => void {
  const listener = (e: Event) =>
    handler((e as CustomEvent<WorkbenchSessionEvent>).detail);
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
